import React from "react"
import PropTypes from 'prop-types'
import { Route, Redirect } from "react-router-dom"
import { connect } from "react-redux"
import LazyRouteLoader from "../components/Common/LazyRouteLoader"

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  requiredClientType,
  requiredClientTypes,
  clientDetail,
  ...rest
}) => {
  const hasClientType = (code) => {
    const clientTypes = clientDetail?.clientTypes || []
    return clientTypes.some(
      (type) => Number(type.clientTypeCode) === Number(code)
    )
  }

  const hasRequiredClientType = () => {
    const codes = requiredClientTypes
      ? requiredClientTypes
      : requiredClientType != null
        ? [requiredClientType]
        : []
    if (!codes.length) return true
    return codes.some((code) => hasClientType(code))
  }

  const needsClientTypeCheck = requiredClientType != null || (requiredClientTypes && requiredClientTypes.length > 0)

  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthProtected && !localStorage.getItem("authUser")) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          )
        }

        if (isAuthProtected && needsClientTypeCheck) {
          if (!clientDetail) {
            return <LazyRouteLoader />
          }
          if (!hasRequiredClientType()) {
            return <Redirect to="/dashboard" />
          }
        }

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        )
      }}
    />
  )
}

AppRoute.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
  requiredClientType: PropTypes.number,
  requiredClientTypes: PropTypes.arrayOf(PropTypes.number),
  clientDetail: PropTypes.object,
}

const mapStateToProps = ({ Profile }) => ({
  clientDetail: Profile.clientDetail,
})

export default connect(mapStateToProps)(AppRoute)
